import { render, staticRenderFns } from "./ResolvedHistoryLayout.vue?vue&type=template&id=cb210c36"
import script from "./ResolvedHistoryLayout.vue?vue&type=script&lang=js"
export * from "./ResolvedHistoryLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../Development/QC/qcheck-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports